import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { GitBranch, ExternalLink, Link2 } from 'lucide-react';
import { onAdminLinkClick } from '../../lib/adminLinks';
import { HelpLink } from './HelpLink';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Read-only: which request this Sales Quote came from or is linked to.
export const RequestTrail = ({ quoteId, token }) => {
  const [o, setO] = useState(undefined);
  useEffect(() => {
    axios.get(`${API_URL}/admin/quotes/${quoteId}/origin`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setO(r.data.origin)).catch(() => setO(null));
  }, [quoteId, token]);
  if (!o) return null;
  return (
    <div className="mx-6 mt-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-sky-200 bg-sky-50/60 px-4 py-3 text-sm" data-testid="request-trail">
      <div className="space-y-0.5">
        <p className="flex items-center gap-2 font-medium text-neutral-900"><GitBranch className="w-4 h-4 text-sky-600" />
          <span data-testid="request-trail-type">{o.type_label}</span>
          {o.reference && <span className="font-mono text-neutral-600" data-testid="request-trail-reference">{o.reference}</span>}
          <HelpLink topic="request-trail" />
        </p>
        <p className="text-xs text-neutral-600 flex items-center gap-1" data-testid="request-trail-source">
          <Link2 className="w-3 h-3" />Source: {o.source_title || o.source_path ? <>{o.source_title || o.source_path}{o.source_path && <span className="text-neutral-400"> ({o.source_path})</span>}{o.source_cta && <> · “{o.source_cta}”</>}</> : 'not recorded'}
        </p>
        {o.missing && <p className="text-xs text-red-600" data-testid="request-trail-missing">The original request record no longer exists.</p>}
      </div>
      {o.view_url && !o.missing && (
        <a href={o.view_url} target={o.external ? '_blank' : undefined} rel="noreferrer" onClick={o.external ? undefined : (e) => onAdminLinkClick(e, o.view_url)}
          className="inline-flex items-center gap-1.5 rounded-md border border-sky-300 bg-white px-3 py-1.5 text-xs font-medium text-sky-800 hover:bg-sky-100 transition-colors" data-testid="request-trail-view">
          <ExternalLink className="w-3.5 h-3.5" />{o.view_label}
        </a>
      )}
    </div>
  );
};
